import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const userServices = {
  switchLoginAccount,

  getOrganizations,

  getMembers,
  getSingleMember,
  statusUpdateMember,

  changePassword,
  getCurrectLoginUser,

  updateProfile,
  sendEmailOTP,
  updateNewEmail,
  regenerateSecretKey,

  checkRegistredUser,
  sendNotificationForRegistration
};

// Get All Member
async function getOrganizations(auth) {
  try {
    const signal = cancelPreviousRequest(`getOrganizations`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getOrganizations`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get All Member
async function getMembers(auth, status, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest(`getMembers/${status}`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getMembers/${status}?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getMembers/${status}?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Member
async function getSingleMember(auth, userId) {
  try {
    const signal = cancelPreviousRequest("getSingleMember");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleMember/${userId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Current User Detail
async function getCurrectLoginUser(auth) {
  try {
    const signal = cancelPreviousRequest("getCurrectLoginUser");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getCurrectLoginUser`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Status Update Member
async function statusUpdateMember(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusUpdateMember`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Change Password
async function changePassword(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}changePassword`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Update Profile
async function updateProfile(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProfile`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Switch Login Account
async function switchLoginAccount(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}switchLoginAccount`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Send Email OTP
async function sendEmailOTP(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendEmailOTP`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Update New Email
async function updateNewEmail(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateNewEmail`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Regenerate Secret key
async function regenerateSecretKey(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}regenerateSecretKey`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

async function checkRegistredUser(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkRegistredUser`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Send Notification for Registration
async function sendNotificationForRegistration(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendNotificationForRegistration`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}